import type { MediaLibraryItem } from '@reactvideoeditor/react-video-editor/types';
import type { Asset } from '@/types/api';
import { assetContentUrl, resolveAssetThumbnailUrl } from '@/rve/orgMediaUrls';

const DEFAULT_WIDTH = 1920;
const DEFAULT_HEIGHT = 1080;
const DEFAULT_VIDEO_DURATION_SEC = 10;

/** Map an Aspectly asset row to an RVE ``MediaLibraryItem`` (org-scoped URLs). */
export function assetToLibraryItem(orgId: number, asset: Asset): MediaLibraryItem | null {
  if (asset.id == null) return null;
  const createdAt = Date.parse(asset.created_at);
  const base = {
    id: String(asset.id),
    url: assetContentUrl(orgId, asset.id),
    name: asset.name,
    createdAt: Number.isFinite(createdAt) ? createdAt : Date.now(),
    thumbnail: resolveAssetThumbnailUrl(orgId, asset),
  };

  if (asset.asset_type === 'image') {
    return {
      ...base,
      type: 'image',
      width: DEFAULT_WIDTH,
      height: DEFAULT_HEIGHT,
      thumbnail: base.thumbnail,
    };
  }

  if (asset.asset_type === 'video') {
    return {
      ...base,
      type: 'video',
      width: DEFAULT_WIDTH,
      height: DEFAULT_HEIGHT,
      duration: DEFAULT_VIDEO_DURATION_SEC,
      thumbnail: base.thumbnail,
    };
  }

  return null;
}
